<template>
    <b-tab
        :active="checked"
        @click="onClick"
        title-item-class="vertical-radio-item"
        title-link-class="vertical-radio-item-link">
        <template slot="title">
            <Icon
                :type="checked ? 'radio_checked_dark' : 'radio'"
                class="mr-2" />
            <slot name="title" />
            <Icon
                class="vertical-radio-item__button-icon d-none d-lg-inline-flex"
                :height="29"
                :width="29"
                :type="icon" />
        </template>
        <horizontal-scrolling-container
            :key="forceRerenderKey"
            wrapper-class="vertical-radio-item__body-wrapper"
            content-class="vertical-radio-item__body">
            <slot name="body" />
        </horizontal-scrolling-container>
    </b-tab>
</template>

<script>
import HorizontalScrollingContainer from '@/components/common/HorizontalScrollingContainer';

export default {
    name: 'VerticalRadioItem',
    components: {
        HorizontalScrollingContainer,
    },
    data () {
        return {
            forceRerenderKey: 0,
        };
    },
    props: {
        checked: { type: Boolean, required: true },
        icon: { type: String, default: '' },
    },
    watch: {
        checked (val) {
            if (val) {
                this.forceRerender();
            }
        },
    },
    methods: {
        onClick () {
            this.$emit('click');
        },
        forceRerender () {
            this.forceRerenderKey += 1;
        },
    },
};
</script>

<style scoped lang="scss">
  ::v-deep .vertical-radio-item__body {
    @include font-arial();
    color: $mb-grey5;
    background-color: $mb-grey-12;
    padding: 15px;
    margin-left: 20px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    font-size: 16px;
    line-height: 26px;
    min-height: 170px;

    @include media-breakpoint-down(xs) {
      margin-left: 0;
      width: 600px;
      min-width: 600px;
      min-height: 0;
      font-size: 12px;
      line-height: 18px;
    }
  }

  ::v-deep .collapsible {
    &__title {
      font-size: 15px;
      color: $mb-grey5;

      @include media-breakpoint-down(xs) {
        font-size: 12px;
      }
    }
  }

  ::v-deep .collapsible__body .card {
    padding-top: 14px;

    @include media-breakpoint-down(xs) {
      padding-top: 12px;
    }
  }
</style>
